import "babel-polyfill";

import "./lib/js/bootstrap";

const $primaryEnvColor = import.meta.env.VITE_PRIMARY_COLOR;
const $secondaryEnvColor = import.meta.env.VITE_SECONDARY_COLOR;

import '../assets/main.scss'

import Vue from 'vue'
window.Vue = Vue;

import App from "@pages/App.vue";
import router from "./router";
import store from "./store";

// Import filter and ui files including call to register them with vue
import * as vueMoment from "./filters/vue-moment";
import * as vueFilters from "./filters/vue-filters";
import * as vueMask from "./filters/vue-mask";
import vuetify from "./ui/vuetify";
import * as  VeeValidate from "./validation/veevalidate";

Vue.config.productionTip = false;

window.taxRate = window.LMP.taxRate;
window.lmpSettings = window.LMP.lmpSettings;
window.gtwPw = window.LMP.gtwPw;
window.showDonation = window.LMP.showDonation;
window.gtwPwEwKey = window.LMP.gtwPwEwKey;

Vue.prototype.appNameUrls = window.LMP.appNameUrls;
Vue.prototype.lmpTz = window.LMP.lmpTz;

// router.afterEach((to, from) => {
//   	window.dispatchEvent(new Event('resize'));
// });

/* eslint-disable no-new */
new Vue({
    // render: h => h(App),
    vuetify,
    router,
    store,
    template: "<App/>",
    components: { App },
}).$mount("#vue-app");
